module.exports = __webpack_public_path__ + "static/Reef-adead9919fb8d3c3d94df454bf27b682.png";